import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Sidebar from "./Sidebar";
import "../style/Followers.css";

const FollowerCard = ({ user }) => {
  // console.log("NEW USER");
  // console.log(user);
  
  const maxDescriptionLength = 300;
  const username = user.attributes?.username || `User${user.id}`;
  const avatar = user.attributes?.picture || "/Avatar.png";
  const description = user.attributes?.description || "";
  const truncatedDescription =
    description.length > maxDescriptionLength
      ? description.substring(0, maxDescriptionLength) + "..."
      : description;
 
  return (
    <div className="card-container" style={{ width: '100%' }}>
      <Link to={`/user/${user.id}`} style={{ textDecoration: 'none', color: 'inherit', display: 'block', width: '100%' }}>
        <div className="follower-card">
          <img className="avatar" src={avatar} alt={`${username}'s avatar`} />
          <div className="follower-info">
            <h3 className="follower-name">{username}</h3>
            <p className="follower-desc">{truncatedDescription}</p>
          </div>
        </div>
      </Link>
    </div>
  );
};

const Followers = () => {
  const [followers, setFollowers] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const userToken = sessionStorage.getItem("token");
  const userId = sessionStorage.getItem("user");

  useEffect(() => {
    // console.log("STARTING");
    if (!userToken || !userId) {
      console.warn("User not logged in. Cannot fetch followers.");
      return;
    }

    const fetchFollowers = async () => {
      // console.log("ignored");
      const followerList = [];   
      try {
        // Fetch connections where the current user is being followed (toUserID = userId)
        const connectionsRes = await fetch(
          `${process.env.REACT_APP_API_PATH}/connections?toUserID=${userId}`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${userToken}`,
            },
          }
        )  
        if (!connectionsRes.ok) {
          throw new Error("Failed to fetch connections");
        }

        const connectionsData = await connectionsRes.json();
        // console.log("CONNECTIONS DATA")
        // console.log(connectionsData); 

        async function getUser(id){
          // console.log("CURRENT ID IS: " + id);
          const req = await fetch(
            `${process.env.REACT_APP_API_PATH}/users/${id}`,
            {
              method: "GET",
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${userToken}`,
              },
            }
          )
          const data = await req.json()
          // console.log("THIS IS DATA");
          // console.log(data);
          return data; 
        } 
 
        const userPromises = connectionsData[0].map(async(connection) => {
          const fromUserID = connection.fromUserID;
          const userRes = await getUser(fromUserID); 
          // console.log("GETUSER");
          // console.log(userRes);
          followerList.push(userRes);
        });

        const users = await Promise.all(userPromises);
        // console.log("FOLLOWERS")
        // console.log(followerList);
        setFollowers(followerList);
        return followerList
      } catch (error) {
        console.error("Error fetching followers:", error);
      }
    }; 
 
    async function fetchFollowersHandler() {
      const newList = await fetchFollowers();
      // console.log("NEWLIST");
      setFollowers(newList)
      // console.log(followers);
      setLoaded(true);
      return newList;
    } 
 
    const waiter = fetchFollowersHandler(); 
    // console.log("WAITER");
    // console.log(waiter);
    }, []);

    if (loaded) {

  return ( 
    <>
      <div className="self-container"> 
        <Sidebar />  
        <div className="content-container"> 
          <h2 className="page-title">USER-NAME'S FOLLOWERS</h2>
          {/* {followers[0].email}  */} 
          {followers.length === 0 ? (
            <p>No followers found.</p>
          ) : (
            followers.map((user, index) => (
              <FollowerCard key={index} user={user} />
            ))
          )}
        </div> 
      </div>
    </>
  );
}
}; 

export default Followers;